import { useCallback, useMemo } from "react";
import { useQuery, useLazyQuery } from "@apollo/client";

import { FETCH_COMPANIES } from "../graphql/query/Company";

export const useCompanies = (props = {}) => {
  const { variables = {} } = props;
  const { data, loading, error } = useQuery(FETCH_COMPANIES(), { variables });
  const companies = useMemo(() => {
    return data?.companies || {};
  }, [data]);
  const count = useMemo(() => {
    return data?.companies?.count || 0;
  }, [data]);

  const findCompanyById = useCallback(
    id => {
      return companies?.edges?.find(company => company.id === id);
    },
    [companies],
  );

  return {
    error,
    loading,
    companies,
    count,
    findCompanyById,
  };
};

export const useCompaniesLazy = (props = {}) => {
  const { variables = {} } = props;
  const [fetchCompanies, { data, loading, error }] =
    useLazyQuery(FETCH_COMPANIES());
  const companies = useMemo(() => {
    return data?.companies || {};
  }, [data]);
  const count = useMemo(() => {
    return data?.companies?.count || 0;
  }, [data]);

  const findCompanyById = useCallback(
    id => {
      return companies?.edges?.find(company => company.id === id);
    },
    [companies],
  );

  return [
    () => fetchCompanies({ variables }),
    { error, loading, companies, count, findCompanyById },
  ];
};
